import type { INavItem } from "app/components/React/SideNavComponents/SideNav.types";

export default function createCompanyPageNavItem(key: string): INavItem {
    return {
        state: key,
        name: "company overview",
        title: "si.account-overview.company.title",
    };
}
